import React, { useEffect } from 'react';
import { array } from 'prop-types';

import { connect } from 'react-redux';

import { get, isEmpty } from 'lodash';

import MaterialTable from 'material-table';
import CircularProgress from '@material-ui/core/CircularProgress';
import Tooltip from '@material-ui/core/Tooltip';

import * as UiActions from '../../../actions/uiActions';
import * as WizardActions from '../../../actions/wizardActions';

import classes from './ProfileTable.module.css';

const WizardSummaryTable = ({
    collectTargetSensors,
    sensorTypes,
    summaries,
    ...props
}) => {

    useEffect(() => {
        async function init() {
            await collectTargetSensors();
        }

        init();
    }, []);

    const getEquipmentStatus = rowData => {
        const allSuccess = rowData.sensors.every(sensor => sensor.status === 'Success');
        const allErrors = rowData.sensors.every(sensor => sensor.status === 'Error');

        const successes = rowData.sensors.filter(sensor => sensor.status === 'Success');
        const errors = rowData.sensors.filter(sensor => sensor.status === 'Error');

        if (allSuccess) {
            return (
                <Tooltip
                    title={
                        <React.Fragment>
                            <span className={classes.tooltip}>{successes.length} sensors created.</span>
                        </React.Fragment>
                    }
                    placement="top-start"
                >
                    <img src="/assets/images/billing-ok.svg" alt="success icon" />
                </Tooltip>
            );
        } else if (allErrors) {
            return (
                <Tooltip
                    title={
                        <React.Fragment>
                            <span className={classes.tooltip}>{errors.length} sensors were not created.</span>
                        </React.Fragment>
                    }
                    placement="top-start"
                >
                    <img src="/assets/images/billing-on-hold.svg" alt="error icon" />
                </Tooltip>
            );
        } else {
            return (
                <Tooltip
                    title={
                        <React.Fragment>
                            <span className={classes.tooltip}>{successes.length} sensors created, {errors.length} sensors not created.</span>
                        </React.Fragment>
                    }
                    placement="top-start"
                >
                    <img src="/assets/images/billing-delinquent.svg" alt="mixture icon" />
                </Tooltip>
            );
        }
    };

    const getStatusIcon = status => {
        const internalStatus = status.toLowerCase();

        switch (internalStatus) {
            case 'success':
                return <img src="/assets/images/billing-ok.svg" alt="success icon" />;
            case 'error':
                return <img src="/assets/images/billing-on-hold.svg" alt="error icon" />;
            default:
                break;
        }
    };

    const getSensorTypeName = rowData => {
        const sensorTypeId = get(rowData, 'sensorTypeId', '');

        if (sensorTypeId) {
            return sensorTypes[0].items.find(type => type.id === sensorTypeId).name;
        }

        return '';
    };

    const getSensorMessage = rowData => {
        if (isEmpty(rowData.messages)) return '';

        const messages = [];

        const MessageKeys = Object.keys(rowData.messages);

        MessageKeys.forEach(key => {
            const message = Object.values(rowData.messages[key]);
            messages.push(message[0]);
        });

        return messages.join(', ');
    };

    if (!summaries.length) return null;

    return (
        <div className={classes.ProfileTable}>
            <div className={classes.title}>
                <h2>Wizard Summary</h2>
            </div>
            <div className={classes.tableContainer}>
                <MaterialTable
                    options={{
                        paging:    false,
                        showTitle: false,
                        search:    false,
                        selection: false,
                        toolbar:   false
                    }}
                    columns={[
                        { title: 'Name', field: 'name' },
                        { title: 'Equipment Type', field: 'type' },
                        {
                            title:  'Status',
                            render: rowData => rowData.isLoading ? <CircularProgress size={25} /> : getEquipmentStatus(rowData)
                        }
                    ]}
                    data={summaries}
                    detailPanel={(rowData, index) => {
                        if (rowData.sensors.length && !rowData.isLoading) {
                            return (
                                <div key={index} className={classes.subTable}>
                                    <MaterialTable
                                        options={{
                                            paging:    false,
                                            showTitle: false,
                                            search:    false,
                                            selection: false,
                                            toolbar:   false
                                        }}
                                        columns={[
                                            { title: 'Sensor Name', field: 'name' },
                                            {
                                                title:  'Sensor Type',
                                                render: childRowData => getSensorTypeName(childRowData)
                                            },
                                            {
                                                title:  'Created',
                                                render: childRowData => getStatusIcon(childRowData.status)
                                            },
                                            {
                                                title:  'Message',
                                                render: childRowData => getSensorMessage(childRowData)
                                            }
                                        ]}
                                        data={rowData.sensors}
                                    />
                                </div>
                            );
                        }
                    }}
                />
            </div>
        </div>
    );
};

WizardSummaryTable.defaultProps = {
    sensorTypes: [],
    summaries:   []
};

WizardSummaryTable.propTypes = {
    sensorTypes: array,
    summaries:   array
};

const mapStateToProps = state => {
    return {
        sensorTypes: state.sensorTypes.data,
        summaries:   state.wizard.summaries
    };
};

const mapDispatchToProps = {
    ...UiActions,
    ...WizardActions
};

export default connect(mapStateToProps, mapDispatchToProps)(WizardSummaryTable);
